// src/index.js
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { FirestoreProvider } from './contexts/FirestoreContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/custom.css';

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <AuthProvider>
      <FirestoreProvider>
        <App />
      </FirestoreProvider>
    </AuthProvider>
  </React.StrictMode>
);

